import { BLOCKS } from '@contentful/rich-text-types'
import { TopLevelBlock } from '@contentful/rich-text-types/dist/types/types'
import { PostContentType } from '../PostContent'
import { slugify } from 'utils/slugify'
import { getTextFromBlock } from 'utils/getTextFromBlock'
import {
  PostTableOfContentsRoot,
  TableOfContentsHeading,
  TableOfContentsList,
  TableOfContentsLink,
} from './PostTableOfContents.styles'
import { useTranslation } from 'hooks/useTranslation'

export type PostTableOfContentsProps = {
  content: PostContentType
}

function getHeadersFromRichText(richText: PostContentType) {
  const headers = (content: TopLevelBlock) =>
    content.nodeType === BLOCKS.HEADING_2;

  return richText.content.filter(headers).map((heading) => {
    const plainText = getTextFromBlock(heading.content);

    return {
      text: plainText,
      href: `#${slugify(plainText)}`,
    };
  });
}

export const PostTableOfContents = ({ content }: PostTableOfContentsProps) => {
  const headers = getHeadersFromRichText(content)
  const { t } = useTranslation()

  if (headers.length === 0) {
    return null
  }

  return (
    <PostTableOfContentsRoot>
      <TableOfContentsHeading>{t('blog:table-of-contents')}</TableOfContentsHeading>
      <TableOfContentsList>
        {headers.map((item, i) => (
          <li key={i}>
            <TableOfContentsLink href={item.href}>{item.text}</TableOfContentsLink>
          </li>
        ))}
      </TableOfContentsList>
    </PostTableOfContentsRoot>
  )
}
